import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from { transform: translateY(100%); }
  to   { transform: translateY(0); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  animation: ${fadeIn} 0.2s ease;
`;

export const Sheet = styled.div<{ $height: number | string }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${({ $height }) =>
    typeof $height === 'number' ? `${$height}px` : $height};
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 7px 7px 0 0;
  overflow: hidden;
  z-index: 101;
  display: flex;
  flex-direction: column;
  animation: ${slideUp} 0.25s ease;
  padding-bottom: env(safe-area-inset-bottom);
`;
